module.exports = __webpack_public_path__ + "videos/Video-presentacion.3b25a638.mov";